import React from 'react';

const NotAuthorize = () => {
  return (
    // <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
    //   <div className="text-center p-4 rounded bg-white shadow-sm">
    //     <h2 className="text-danger mb-3">Access Denied</h2>
    //     <p className="text-muted">You are not authorized to access this page.</p>
    //   </div>
    // </div>
    <></>
  );
};

export default NotAuthorize;
